// extracted by mini-css-extract-plugin
export default {"pleaseWait":"styles-module__pleaseWait__XtHuh","cookieButton":"styles-module__cookieButton__gls9C"};